import script from "./full-loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./full-loading.vue?vue&type=script&setup=true&lang=ts"

import "./full-loading.vue?vue&type=style&index=0&id=f199e6fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f199e6fe"]])

export default __exports__